var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sortable-header-cell",class:[_vm.order, { active: _vm.active }],on:{"click":_vm.toggleSort}},[_vm._v("\n  "+_vm._s(_vm.label)+"\n  "),_c('img',{attrs:{"src":_vm.arrowIcon}})])}
var staticRenderFns = []

export { render, staticRenderFns }